module.exports = __webpack_public_path__ + "static/img/goodness5.7d2b7046.png";